import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Menu, Layout, Tabs, Button } from 'antd';
import Prospects from './trackedProspects/Prospects';
import ProspectIdentification from './prospectIdentification/ProspectIdentification';
import Settings from './userSettings/Settings';
import store from '../reducers/store';
import logout from '../authentication/logout';
import zmailLogo from '../img/zmail_logo.png';
import zcruitLogo from '../img/zcruit_logo.png';
import { Cookies } from 'react-cookie';

import userService from '../services/userService';

const { Header, Content } = Layout;
const TabPane = Tabs.TabPane;
const Item = Menu.Item;

class Dashboard extends Component {
  goToSettingsPage() {
    this.props.history.push('/settings');
  }

  logoutUser() {
    userService.logout().then(
      () => {
        this.props.history.push('/login');
      },
      () => {
        console.warn('failed to log out');
      }
    );

    localStorage.removeItem('organization_id');
    localStorage.removeItem('user_id');

    store.dispatch({ type: 'UPDATE_LOGGEDIN', loggedIn: false });
    store.dispatch({ type: 'UPDATE_LOADED_CREDENTIALS', loadedCredentials: false });
    store.dispatch({ type: 'UPDATE_LOADED_LISTS', loadedLists: false });
    store.dispatch({ type: 'LOADING_PLAYERS', loadingPlayers: false });
    store.dispatch({ type: 'FINISHED_LOADING_PLAYERS', finishedLoadingPlayers: false });

    this.props.history.push('/login');
  }

  menuClicked(item) {
    switch (item.key) {
      case 'logout':
        this.logoutUser();

        return;
      default:
        this.setState({
          targetUser: item.key,
        });
        store.dispatch({
          type: 'UPDATE_DISPLAYED_USER',
          displayedUser: this.getUserFomKey(item.key),
        });

        return;
    }
  }

  getUserFomKey(key) {
    const index = this.props.schoolUsersList.findIndex((user) => {
      return user.id === key;
    });

    return this.props.schoolUsersList[index];
  }

  getSchoolUsers() {
    let users = this.props.schoolUsersList;

    users = this.props.schoolUsersList.filter((user) => {
      return user.id !== this.props.displayedUser.id;
    });

    return users.map((user) => {
      return (
        <Item username={user.username} key={user.id}>
          {user.username}
        </Item>
      );
    });
  }

  editUser(newUsername) {
    this.setState({
      username: newUsername,
    });
  }

  sendToZcruit() {
    window.open(`${process.env.ZCRUIT_BASE_URL}/redirect/`, '_blank');
  }

  render() {
    if (!this.props.displayedUser) return null;

    const menu = (
      <Menu onClick={this.menuClicked.bind(this)}>
        {this.getSchoolUsers()}
        <Item key='logout'>
          <p>Logout</p>
        </Item>
      </Menu>
    );

    return (
      <Layout>
        <Header>
          {this.props.organization.package.is_zmail && (
            <img src={zmailLogo} className='headerLogo' alt='Zmail Logo' />
          )}
          {!this.props.organization.package.is_zmail && (
            <a onClick={this.sendToZcruit.bind(this)}>
              <img src={zcruitLogo} className='headerLogo' alt='Zcruit Logo' />
            </a>
          )}
          <Dropdown trigger={['click']} overlay={menu} placement='bottomCenter'>
            <Button
              className='settingsButton'
              type='dashed'
              disabled={this.props.organization.package.is_zmail}>
              {this.props.displayedUser.username}
            </Button>
          </Dropdown>
        </Header>
        <Content>
          <Tabs defaultActiveKey={this.props.redirected ? '1' : '2'}>
            {this.props.organization.package.is_zmail && (
              <TabPane tab='Tracked Prospects' key='1'>
                {' '}
                <Prospects />{' '}
              </TabPane>
            )}
            <TabPane tab='Prospect Identification' key={this.props.redirected ? '1' : '2'}>
              {' '}
              <ProspectIdentification />
            </TabPane>
            <TabPane tab='Settings' key={this.props.redirected ? '2' : '3'}>
              <Settings history={this.props.history} />
            </TabPane>
          </Tabs>
        </Content>
      </Layout>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    loggedIn: storeState.main.loggedIn,
    loadedCredentials: storeState.main.loadedCredentials,
    loadedLists: storeState.lists.loadedLists,
    redirected: storeState.main.redirected,
    displayedUser: storeState.main.displayedUser,
    schoolUsersList: storeState.lists.schoolUsersList,
    organization: storeState.main.organization,
  };
}

export default connect(mapStoreToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js